module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/NVPC-efc2387fc4de444d7372364e7a2a6cff.png";